import PropTypes from 'prop-types'
import { memo, useEffect, useMemo, useRef } from 'react'
import classNames from 'lib/util/classNames'
import { useTooltipContext } from '../../provider/TooltipProvider'
import styles from './Wrapper.module.scss'

/**
 * The `Wrapper`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Wrapper (props) {
  const { isTooltipActive: isActive, setTooltipRef } = useTooltipContext()
  const ref = useRef()
  const classNameOutput = useMemo(
    () => classNames([styles.wrapper, isActive && styles.active]),
    [isActive]
  )

  /**
   * Effect: On mount, set the tooltip ref
   */
  useEffect(() => {
    setTooltipRef(ref)
  }, [])

  return <div ref={ref} className={classNameOutput} />
}

/** @type {object} */
Wrapper.propTypes = {
  isActive: PropTypes.bool,
  locationStart: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  })
}

/** @type {object} */
Wrapper.defaultProps = {
  isActive: true,
  locationStart: {
    x: 0,
    y: 0
  }
}

// Memoize
export default memo(Wrapper)
